import React, { useEffect, useState } from "react";
import API from '../Services/LoyalityPoint'
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";

const LoyalityPoints = () => {
    const [playPoint, setPlayPoint] = useState("")
    const [loyalityPoint, setLoyalityPoint] = useState("")
    const [loyalityList, setLoyalityList] = useState([])
    const [errors, setErrors] = useState({});
    const [isEditing, setIsEditing] = useState(false);
    const [editId, setEditId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const perPage = 10;
    const [createdDate, setCreatedDate] = useState("")
    const [status, setStatus] = useState("")


    useEffect(() => {
        getLoyalityList()
    }, [currentPage])


    const validateFields = () => {
        const errors = {};
        const playPointValue = String(playPoint || "");
        const loyalityPointValue = String(loyalityPoint || "");
        if (!playPointValue.trim()) {
            errors.playPoint = "SkyCoins is required";
        } else if (isNaN(parseFloat(playPointValue))) {
            errors.playPoint = "SkyCoins must be a valid number";
        }
        if (!loyalityPointValue.trim()) {
            errors.loyalityPoint = "Loyality point is required";
        } else if (isNaN(parseFloat(loyalityPointValue))) {
            errors.loyalityPoint = "Loyality point must be a valid number";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };


    const handleFieldChange = (e, fieldName) => {
        const value = e.target.value;
        if (value.trim()) {
            setErrors((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors[fieldName];
                return updatedErrors;
            });
        }

        switch (fieldName) {
            case "playPoint":
                setPlayPoint(value);
                break;
            case "loyalityPoint":
                setLoyalityPoint(value);
                break;
            default:
                break;
        }
    };



    // const addLoyalityList = async () => {
    //     if (!validateFields()) return;
    //     const payload = {
    //         play_point_spent: playPoint,
    //         loyality_program: loyalityPoint,
    //         is_active: true
    //     }
    //     try {
    //         const response = await API.addLoyalityPoint(payload)
    //         if (response?.status === 200) {
    //             toast.success(response?.data?.message || "Loyality Point Created Successfully!");
    //             setTimeout(() => window.location.reload(), 2000);
    //         }
    //         else {
    //             toast.error(response?.data?.message || "Loyality Point failed.");
    //         }
    //     } catch (error) {
    //         console.error("Axios error:", error);
    //         if (error.response.status == 403) {
    //             window.location.replace("/Login");
    //         }
    //         if (error.response) {
    //             console.error("Response data:", error.response.data);
    //             console.error("Response status:", error.response.status);

    //             const errorMessage =
    //                 error.response.data?.message || `Error: ${error.response.status}`;
    //             toast.error(errorMessage);
    //         } else if (error.request) {
    //             console.error("Request error:", error.request);
    //             toast.error("No response from server. Please try again later.");
    //         } else {
    //             console.error("Error message:", error.message);
    //             toast.error("Something went wrong. Please try again.");
    //         }
    //     }

    // }

    const onCancel = () => {
        setTimeout(() => window.location.reload());
        setPlayPoint("");
        setLoyalityPoint("");
        setErrors({});
        setIsEditing(false);
        setEditId(null);
    }

    const getLoyalityList = async () => {
        try {
            const payload = {
                limit: perPage,
                pageNumber: currentPage
            };
            const response = await API.getLoyalityPoint(payload);
            // console.log("response data...", response?.data?.data?.count)
            setLoyalityList(response?.data?.data?.rows || []);
            setTotalRecords(response?.data?.data?.count)
        } catch (error) {
            toast.dismiss();
            if (!error.response) {
                toast.error("Network error! Please check your internet connection");
            } else if (error.response.status === 403) {
                window.location.replace("/Login")
                toast.error("Network error! Please check your internet connection.");
            } else {
                toast.error("An unexpected error occurred. Please try again.");
            }
        }
    };

    const totalPages = Math.ceil(totalRecords / perPage);
    const handlePageChange = (page) => {
        if (page > 0 && page <= totalPages) {
            setCurrentPage(page);
            // getLoyalityList();
        }
    };

    const getPageNumbers = () => {
        const maxVisible = 10;
        const pageNumbers = [];
        if (totalPages <= maxVisible) {
            for (let i = 1; i <= totalPages; i++) {
                pageNumbers.push(i);
            }
        } else {
            const left = Math.max(1, currentPage - 3);
            const right = Math.min(totalPages, currentPage + 3);
            if (left > 2) {
                pageNumbers.push(1, '...');
            } else {
                for (let i = 1; i < left; i++) {
                    pageNumbers.push(i);
                }
            }
            for (let i = left; i <= right; i++) {
                pageNumbers.push(i);
            }
            if (right < totalPages - 1) {
                pageNumbers.push('...', totalPages);
            } else {
                for (let i = right + 1; i <= totalPages; i++) {
                    pageNumbers.push(i);
                }
            }
        }
        return pageNumbers;
    };


    const handleError = (error) => {
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");
        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };


    const changeLoyalityData = (id) => {
        const selectedLoyality = loyalityList.find((item) => item.id === id);
        // console.log("seleeee....", selectedLoyality)
        if (selectedLoyality) {
            setPlayPoint(selectedLoyality.play_point_spent);
            setLoyalityPoint(selectedLoyality.loyality_program);
            setCreatedDate(selectedLoyality?.createdAt);
            setStatus(selectedLoyality?.is_active)
            setIsEditing(true);
            setEditId(id);
            window.scrollTo({
                top: 0,
                behavior: 'smooth',
            });
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        const payload = {
            play_point_spent: playPoint,
            loyality_program: loyalityPoint,
            is_active: true,
        };
        try {
            let response;
            if (isEditing) {
                response = await API.updateLoyality(editId, payload);
                if (response?.status === 200) {
                    toast.success(response?.message || "Loyality Point Updated Successfully!");
                    setTimeout(() => window.location.reload(), 2000);
                }
            } else {
                response = await API.addLoyalityPoint(payload);
                if (response?.status === 200) {
                    toast.success(response?.message || "Loyality Point Created Successfully!");
                    setTimeout(() => window.location.reload(), 2000);
                }
            }
            getLoyalityList()
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            // setTimeout(() => window.location.reload(), 10000);
        }
    };

    return (
        <div>
            <div >
                <div className="col-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <h4 className="card-title">Loyality Point</h4>
                            <div className="forms-sample">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="name">SkyCoins Spend <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtPlay"
                                                placeholder="SkyCoins Spend"
                                                value={playPoint}
                                                onChange={(e) => handleFieldChange(e, "playPoint")}
                                            />
                                            {errors.playPoint && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.playPoint}</span>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group">
                                            <label htmlFor="name">Loyality Point Allocation <span style={{ color: "red" }}>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="txtLoyal"
                                                placeholder="Loyality Point Allocation"
                                                value={loyalityPoint}
                                                onChange={(e) => handleFieldChange(e, "loyalityPoint")}
                                            />
                                            {errors.loyalityPoint && <span className="text-danger" style={{ fontSize: "12px" }}>{errors.loyalityPoint}</span>}
                                        </div>
                                    </div>
                                </div>

                                <div className="mt-3">
                                    <button type="button" className="btn btn-primary" onClick={handleSubmit}>
                                        {isEditing ? "Update" : "Submit"}
                                    </button>
                                    <button className="btn btn-light ms-3" onClick={onCancel}>Cancel</button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-header d-flex justify-content-between align-items-center">
                        <h4 className="card-title mb-0">Added Loyality Point</h4>
                    </div>

                    <div className="card-body">
                        <table className="table table-bordered text-center">
                            <thead>
                                <tr>
                                    <th>SrNo</th>
                                    <th>Action</th>
                                    <th>SkyCoins</th>
                                    <th>Loyality Point Allocation</th>
                                    <th>Status</th>
                                    <th>Created-Date</th>


                                </tr>
                            </thead>
                            <tbody>
                                {loyalityList.map((loyality, index) =>
                                (
                                    console.log("loyality...", loyality),
                                    <tr key={loyality.id}>
                                        <td>{(currentPage - 1) * perPage + index + 1}</td>
                                        {/* <td> */}
                                        {/* <button className="btn btn-success btn-sm"
                                                onClick={() => changeLoyalityData(loyality.id)} >Edit</button> */}
                                        {/* <button
                                                className={`btn btn-sm ${loyalityList.is_active ? "btn-danger" : "btn-info"}`}
                                                // onClick={() => handleStatusToggle(loyalityList.id, loyalityList.is_active)}
                                            >
                                                {loyalityList.is_active ? "Deactivate" : "Activate"}
                                            </button> */}
                                        {/* </td> */}
                                        <td>
                                            <div className="navbar-menu-wrapper d-flex align-items-stretch" style={{ justifyContent: 'center', alignItems: "center", display: "flex" }}>
                                                <ul className="navbar-nav navbar-nav-right">
                                                    <li className="nav-item nav-profile1">
                                                        <span className="nav-link dropdown-toggle1 text-center" id="actionDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false">
                                                            <div className="nav-profile-text1">
                                                                <p className="mb-1 text-black">
                                                                </p>
                                                            </div>
                                                        </span>
                                                        <span className="nav-link mdi mdi-menu" style={{ width: "50px", fontSize: "30px", color: "black", }} id="profileDropdown" href="#" data-bs-toggle="dropdown" aria-expanded="false"></span>
                                                        <div className="dropdown-menu navbar-dropdown" aria-labelledby="actionDropdown">
                                                            <a className="dropdown-item">
                                                                <button onClick={() => changeLoyalityData(loyality.id)} className="btn btn-success btn-sm" type="button" data-bs-toggle="modal" data-bs-target="#myModalTaxView">
                                                                    View
                                                                </button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            <a className="dropdown-item">
                                                                {/* <button className="btn btn-primary btn-sm" onClick={() => handleGetData(item.id)}>Edit</button>{' '} */}
                                                                <button className="btn btn-primary btn-sm"
                                                                    onClick={() => changeLoyalityData(loyality.id)} >Edit</button>
                                                            </a>
                                                            <div className="dropdown-divider"></div>
                                                            {/* <a className="dropdown-item">
                                                                <button
                                                                    className={`btn btn-sm ${item.is_active ? "btn-secondary" : "btn-info"}`}
                                                                    onClick={() => handleStatusToggle(item.id, item.is_active)}
                                                                >
                                                                    {item.is_active ? "Deactivate" : "Activate"}
                                                                </button>
                                                          
                                                            </a> */}
                                                        </div>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>

                                        <td>{loyality?.play_point_spent}</td>
                                        <td>{loyality?.loyality_program}</td>
                                        <td>{loyality?.is_active ? "Active" : "De-Activated"}</td>
                                        <td>
                                            {moment(loyality?.createdAt).format("DD-MM-YYYY")}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <nav aria-label="Page navigation example">
                            <ul className="pagination justify-content-center  mt-3">
                                <li className={`page-item ${currentPage === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 1}
                                    >
                                        Previous
                                    </button>
                                </li>

                                {/* {Array.from({ length: totalPages }, (_, index) => (

                                    <li
                                        key={index + 1}
                                        className={`page-item ${currentPage === index + 1 ? "active" : ""}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => handlePageChange(index + 1)}
                                        >
                                            {index + 1}
                                        </button>
                                    </li>
                                ))} */}
                                {getPageNumbers().map((page, index) => (
                                    <li
                                        key={index}
                                        className={`page-item ${page === currentPage ? "active" : ""} ${page === "..." ? "disabled" : ""}`}
                                    >
                                        {page === "..." ? (
                                            <span className="page-link">...</span>
                                        ) : (
                                            <button className="page-link" onClick={() => handlePageChange(page)}>
                                                {page}
                                            </button>
                                        )}
                                    </li>
                                ))}

                                <li
                                    className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                >
                                    <button
                                        className="page-link"
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage === totalPages}
                                    >
                                        Next
                                    </button>
                                </li>
                            </ul>
                        </nav>
                    </div>

                </div>
            </div>
            <ToastContainer />
            <section>
                <div className="modal" id="myModalTaxView" data-bs-backdrop="static">
                    <div className="modal-dialog modal-lg" style={{ width: "800px" }}>
                        <div className="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title">Loyality Point Details</h5>
                                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div class="modal-body">
                                <div className="col-lg-12 grid-margin stretch-card">
                                    <div className="card">
                                        <div className="card-body">
                                            <div className="table-responsive">
                                                <table className="table table-bordered text-center">
                                                    <thead>
                                                        <tr>
                                                            <th>SkyCoins Spend</th>
                                                            <th>Loyality Point Allocation</th>
                                                            <th>Created Date</th>
                                                            <th>Status</th>
                                                        </tr>
                                                        <tr>
                                                            <td>{playPoint}</td>
                                                            <td>{loyalityPoint}</td>
                                                            <td>{moment(createdDate).format("DD-MM-YYYY")}</td>
                                                            <td>{status ? "Active" : "De-Activated"}</td>
                                                        </tr>
                                                    </thead>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    );
};

export default LoyalityPoints;